(() => {
  if (customElements.get('ubiquiti-specialist-panel')) return;

  class UbiquitiSpecialistPanel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.group = this.dataset.group || '';
      this.overlay = this.querySelector('[data-ubq-specialist-overlay]');
      this.closeBtn = this.querySelector('[data-ubq-specialist-close]');
      this.panel = this.querySelector('.ubq-specialist__panel');
      this.form = this.querySelector('.ubq-specialist__form');
      this.success = this.querySelector('[data-ubq-specialist-success]');
      this.intro = this.querySelector('[data-ubq-specialist-intro]');
      this.fileInput = this.querySelector('[data-ubq-specialist-files]');
      this.fileName = this.querySelector('[data-ubq-specialist-filename]');
      this.submitBtn = this.querySelector('[data-ubq-specialist-submit]');
      this._defaultFileText = this.fileName ? this.fileName.textContent : '';
      this._submitLabel = this.submitBtn ? this.submitBtn.textContent : '';

      this._onTrigger = this._onTrigger.bind(this);
      this._onClose = () => this.setOpen(false);
      this._onKeydown = (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.setOpen(false);
      };
      this._onSubmit = this._onSubmit.bind(this);

      document.addEventListener('click', this._onTrigger);
      document.addEventListener('keydown', this._onKeydown);
      if (this.overlay) this.overlay.addEventListener('click', this._onClose);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this._onClose);
      if (this.form) this.form.addEventListener('submit', this._onSubmit);
      if (this.fileInput) {
        this.fileInput.addEventListener('change', () => this._renderFileNames());
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onTrigger);
      document.removeEventListener('keydown', this._onKeydown);
      if (this.classList.contains('is-open')) document.body.classList.remove('ubq-specialist-open');
    }

    _onTrigger(e) {
      const btn = e.target.closest('[data-ubq-specialist-open]');
      if (!btn) return;
      const target = btn.getAttribute('data-ubq-specialist-target');
      if (target && target !== this.group) return;
      e.preventDefault();
      this._trigger = btn;
      this.setOpen(true);
    }

    setOpen(open) {
      if (open) {
        if (this.form) {
          this.form.hidden = false;
          this.form.reset();
        }
        if (this.intro) this.intro.hidden = false;
        if (this.success) this.success.hidden = true;
        if (this.fileName) this.fileName.textContent = this._defaultFileText;
        if (this.submitBtn) {
          this.submitBtn.disabled = false;
          this.submitBtn.textContent = this._submitLabel;
        }
        if (this.overlay) this.overlay.hidden = false;
      } else if (this.overlay) {
        this.overlay.hidden = true;
      }

      this.classList.toggle('is-open', open);
      document.body.classList.toggle('ubq-specialist-open', open);

      if (open) {
        const first = this.querySelector('.ubq-specialist__form input, .ubq-specialist__form select, .ubq-specialist__form textarea');
        if (first) window.setTimeout(() => first.focus(), 80);
      } else if (this._trigger) {
        this._trigger.focus();
        this._trigger = null;
      }
    }

    _renderFileNames() {
      if (!this.fileName || !this.fileInput) return;
      const files = Array.from(this.fileInput.files || []);
      this.fileName.textContent = files.length
        ? files.map((f) => f.name).join(', ')
        : this._defaultFileText;
    }

    _onSubmit(e) {
      e.preventDefault();
      if (!this.form) return;

      const files = this.fileInput ? Array.from(this.fileInput.files || []) : [];
      const api = window.TpuStorefrontEnquiry;
      if (!api || typeof api.runEnquirySubmit !== 'function') {
        if (window.ModalToast) {
          window.ModalToast.show(
            "Thanks — we've received your enquiry and will be in touch shortly.",
          );
        }
        this.setOpen(false);
        return;
      }

      const fv = (name) => api.fieldValue(this.form, name);
      api
        .runEnquirySubmit({
          button: this.submitBtn,
          successEl: this.success,
          payload: {
            enquiryType: 'specialist',
            enquiryTypeLabel: fv('contact[Enquiry type]') || 'Talk to a Specialist',
            name: fv('contact[Name]'),
            businessName: fv('contact[Business name]'),
            email: fv('contact[email]'),
            phone: fv('contact[Phone]'),
            projectType: fv('contact[Project type]'),
            numberOfUsers: fv('contact[Number of users]'),
            budget: fv('contact[Budget]'),
            notes: fv('contact[body]'),
            attachedFileNames: files.map((f) => f.name),
          },
          onSuccess: () => {
            this.setOpen(false);
            if (this.form) this.form.hidden = false;
            if (this.intro) this.intro.hidden = false;
            if (this.success) this.success.hidden = true;
          },
        })
        .catch(() => {});
    }
  }

  customElements.define('ubiquiti-specialist-panel', UbiquitiSpecialistPanel);
})();
